import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cdaaeba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-organization" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "Vergebe einen Namen für deine Organisation.", -1))
const _hoisted_3 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_overlay = _resolveComponent("md-overlay")!

  return (_openBlock(), _createBlock(_component_md_overlay, {
    closeable: true,
    title: "Neue Organisation erstellen",
    ref: "overlay"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_md_input_field, {
          required: "",
          variant: "filled",
          modelValue: _ctx.orgName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orgName) = $event)),
          label: "Name der Organization",
          ref: "nameInput",
          onKeydown: _withKeys(_ctx.addOrganization, ["enter"])
        }, null, 8, ["modelValue", "onKeydown"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_md_button, {
            variant: "filled",
            disabled: _ctx.orgName.length <= 0,
            onClick: _ctx.addOrganization
          }, {
            default: _withCtx(() => [
              _createTextVNode("Organisation erstellen")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}